import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resumedCarrierFailed, resumedCarrierSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* resumedCarrier(action) {
  try {
    const { id, values } = action.payload;
    if (!id) { throw new Error('ID not found'); }
    const url = `${BACKEND_URL}/registries/carriers/${id}/resumed`;
    const response = yield makeRequest(url, {}, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(resumedCarrierSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(resumedCarrierFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(resumedCarrierFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
